import { Card, CardContent, Stack, SvgIcon, Typography } from '@mui/material';

import { ReactComponent as AssessmIcon } from 'assets/images/assessm_template.svg';

const NoCustomTemplateCard = (): React.ReactElement => (
  <Card variant="outlined">
    <CardContent>
      <SvgIcon
        component={AssessmIcon}
        inheritViewBox
        className="view-icon"
        fontSize="inherit"
        htmlColor="#3D3C42"
      />
      <Stack
        direction="column"
        spacing={4}
        justifyContent="center"
        alignItems="center"
      >
        <Typography variant="h6">No custom templates found</Typography>
        <Typography component="span">
          Create your first custom template to get started.
        </Typography>
      </Stack>
    </CardContent>
  </Card>
);

export default NoCustomTemplateCard;
